import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { Grid, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../Components/AuthContext";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { LoaderBox } from "../Components/LoaderBox";
import { DropDownList } from "../Components/DropDownList";

export function CultivarEditar() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const id = state?.id;
  const [isLoading, setLoading] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const { user } = useAuth();
  const [nombre, setNombre] = React.useState("");
  const [descripcion, setDescripcion] = React.useState("");
  const [subproducto, setSubproducto] = React.useState({ Id: "", Nombre: "" });
  const [tipoCultivo, setTipoCultivo] = React.useState({ Id: "", Nombre: "" });

  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/Cultivar",
    pageState: {},
  });

  React.useEffect(() => {
    if (!state) {
      navigate("/Cultivar", { replace: true });
    }
  }, [state, navigate]);

  React.useEffect(() => {
    if (!id) return;
    instance
      .get("/cultivo/cultivar/" + id)
      .then((res) => {
        const data = res.data;
        setNombre(data.Nombre);
        setDescripcion(data.Descripcion);
        setSubproducto({ Id: data.Id_Producto, Nombre: "" });
        setTipoCultivo({ Id: data.Id_Tipo_Cultivo, Nombre: "" });
      })
      .catch((err) => {
        if (err.response && err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message || "Error desconocido" });
        }
        setOpenDialog(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: id,
      nombre: addEspaceCharacters(info.nombre.value),
      descripcion: addEspaceCharacters(info.descripcion.value),
      subProducto: subproducto.Id,
      tipoCultivo: tipoCultivo.Id,
    };
    instance
      .put("/cultivo/cultivar", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: "Se ha actualizado el cultivar de forma exitosa.",
          redirect: true,
          page: "/Cultivar",
        });
      })
      .catch((err) => {
        if (err.response && err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message || "Error desconocido" });
        }
      })
      .finally(() => setOpenDialog(true));
  };

  if (!state) return null;

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <Typography component="h1" variant="h5">
            Editar cultivar
          </Typography>
          <Grid
            container
            component="form"
            sx={{ mt: 1, display: "flex", flexDirection: "column" }}
            onSubmit={handleSubmit}
          >
            <Grid item sx={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
              <DropDownList
                required
                title="Subproducto"
                endpoint={"/producto/listAllSemillas"}
                selected={subproducto.Id}
                selectedItem={subproducto}
                setSelectedItem={setSubproducto}
              />
            </Grid>
            <Grid item sx={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
              <DropDownList
                required
                title="Cultivo"
                endpoint={"/cultivo/tipos/active"}
                selected={tipoCultivo.Id}
                selectedItem={tipoCultivo}
                setSelectedItem={setTipoCultivo}
              />
            </Grid>
            <Grid>
              <TextField
                margin="normal"
                required
                fullWidth
                label="Nombre del cultivar"
                id="nombre"
                name="nombre"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                autoFocus
                inputProps={{ maxLength: 100 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid>
              <TextField
                id="descripcion"
                name="descripcion"
                label="Descripción"
                multiline
                required
                fullWidth
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                inputProps={{ maxLength: 250 }}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                color="success"
              >
                Actualizar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}
